import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {getRoutes} from '@epic-core/utils/dist/RouteUtils';
import {generateRoutePath} from '@epic-core/common';
import {LauncherIntegrationUtils} from 'epic-launcher-integration/app/scripts';
import getRouteDefinitions from './routes/routes';
import {getCurrentLocale, CustomizedHistory, ResizeObserver} from './utils';
import ExternalScript from './components/globalHeaderFooter/ExternalScript';
import {ShoppingCartActions, ConfigActions} from './actions';
import {PageLayout} from './pages';

const mapStateToProps = state => {
    const {
        includeGlobalHeader,
        includeGlobalFooter,
        isShoppingCartEnabled,
        helmetData,
        isLauncher,
        customizedHistory
    } = state.get('config').toJS();
    const {isLoggedIn} = state.get('user').toJS();
    return {
        localizationState: state.get('localization'),
        includeGlobalHeader,
        includeGlobalFooter,
        isShoppingCartEnabled,
        isLoggedIn,
        helmetData,
        isLauncher,
        customizedHistory
    };
};
const mapDispatchToProps = dispatch => {
    return {
        listOffers: () => {
            dispatch(ShoppingCartActions.getOffers());
        },
        getLauncherOptions: model => {
            dispatch(ConfigActions.getLauncherOptions(model));
        },
        setConfig: model => {
            dispatch(ConfigActions.setConfig(model));
        }
    };
};

@connect(mapStateToProps, mapDispatchToProps)
class App extends React.Component {
    componentDidMount() {
        LauncherIntegrationUtils.initWebIntegration();
        const {
            isLoggedIn,
            listOffers,
            isLauncher,
            getLauncherOptions,
            isShoppingCartEnabled,
            history
        } = this.props;
        if (isLoggedIn) {
            listOffers();
        }
        if (isLauncher) {
            getLauncherOptions({isShoppingCartEnabled});
        }
        this.unlisten = history.listen(this.setPageLocation);
        this.setPageLocation(history.location);
    }

    componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
        }
        if (ResizeObserver()) {
            ResizeObserver().disconnect();
        }
    }

    setPageLocation = location => {
        let {customizedHistory} = this.props;
        const {setConfig} = this.props;
        if (!customizedHistory) {
            const defaultLocation = generateRoutePath('store');
            customizedHistory = new CustomizedHistory(defaultLocation);
        }
        customizedHistory.push(location);
        setConfig({
            customizedHistory
        });
    };

    render() {
        const {
            mobile,
            tablet,
            msie,
            location,
            isShoppingCartEnabled,
            includeGlobalHeader,
            includeGlobalFooter,
            isLoggedIn,
            isLauncher
        } = this.props;
        const classes = classNames(
            `epic-marketplace store-page-asset ${
                isShoppingCartEnabled ? 'enableShoppingCart' : ''
            } ${isLoggedIn ? '' : 'not-logged-in'}`,
            {
                mobile,
                tablet,
                msie
            }
        );
        const routeDefinitions = getRouteDefinitions();
        const routes = getRoutes(routeDefinitions, location);

        return (
            <div className={`site-content ${isLauncher ? 'launcher-scrollbar' : ''}`}>
                {includeGlobalHeader && (
                    <ExternalScript lang={getCurrentLocale(location || '')} type="header" />
                )}

                <div id="epic-marketplace" className={classes}>
                    <PageLayout>{routes}</PageLayout>
                </div>

                {includeGlobalFooter && (
                    <ExternalScript lang={getCurrentLocale(location || '')} type="footer" />
                )}
            </div>
        );
    }
}
App.propTypes = {
    location: PropTypes.object.isRequired,
    includeGlobalHeader: PropTypes.bool,
    includeGlobalFooter: PropTypes.bool,
    mobile: PropTypes.bool,
    tablet: PropTypes.bool,
    msie: PropTypes.bool,
    isShoppingCartEnabled: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    listOffers: PropTypes.func,
    history: PropTypes.object,
    isLauncher: PropTypes.bool,
    getLauncherOptions: PropTypes.func,
    setConfig: PropTypes.func,
    customizedHistory: PropTypes.object
};
export default withRouter(App);
